import DOMPurify from 'dompurify';

class TranslationHelper {

    TranslateRaw = (translations, key) => {

        if (key == null)
            return "";

        const translation = translations.find(obj => obj.key.toLowerCase() === key.toLowerCase());
        return translation ? translation.value : localStorage.getItem("debug") === "1" ? key : '';
    }

    Translate = (translations, key, raw = false, args = []) => {
        let translation = this.TranslateRaw(translations, key);

        if (args.length > 0)
            translation = this.TranslateReplace(translation, args);

        if (raw)
            return translation;

        return <div className='loc' dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(translation, { ADD_TAGS: ["iframe"], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'class', 'target'] })
        }}></div>
    }

    TranslateReplace = (translation, replaceArgs) => {

        if (typeof replaceArgs === 'string')
            replaceArgs = [replaceArgs];

        if (!Array.isArray(replaceArgs))
            return translation;

        for (let i in replaceArgs) {
            let placeholder = `{${i}}`;
            translation = translation.replace(placeholder, replaceArgs[i]);
        }

        return translation;
    }
}

export default TranslationHelper;